import actionTypes from '../../action-types'

export default (payload, included) => ({
  type: actionTypes.CUSTOMER_PRODUCTS.SET,
  payload,
  included,
})
